import React, { useState, useEffect } from "react";


import {
  Search,
  MoreVertical,
} from "lucide-react";

import {
  getAllDriverPayouts,
  deleteDriverPayout,
} from "../../api/DriverPayoutApi.js";
import AddDriverPayoutModal from "./AddDriverPayoutModal.jsx";
import ViewDriverPayoutModal from "./ViewDriverPayoutModal.jsx";
import EditDriverPayoutModal from "./EditDriverPayoutModal.jsx";
import { toast } from "../shared/Toast.jsx";
import { showConfirm } from "../shared/ConfirmContext.jsx";

const StatCard = ({ value, label, active, onClick }) => (

  <div
    onClick={onClick}
    style={{
      background: active ? "#E8F5EE" : "#fff",
      flex: 1,
      borderRadius: 8,
      padding: 20,
      cursor: "pointer",
      border: active ? "2px solid #20B967" : "2px solid transparent",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <div
      style={{
        fontSize: 45,
        fontWeight: 700,
        color: "#20B967",
      }}
    >
      {value}
    </div>

    <div
      style={{
        marginTop: 10,
        fontWeight: 600,
      }}
    >
      {label}
    </div>
  </div>
);


const TableHeader = () => (
  <div
    style={{
      display: "flex",
      background: "#212A30",
      color: "#fff",
      padding: 12,
      fontWeight: 600,
      fontSize: 13,
    }}
  >
    <div style={{ flex: 2 }}>Driver</div>

    <div style={{ flex: 1.5 }}>Company</div>

    <div style={{ flex: 1 }}>Trips</div>

    <div style={{ flex: 1 }}>Amount</div>

    <div style={{ flex: 1 }}>Deduction</div>

    <div style={{ flex: 1 }}>Payable</div>

    <div style={{ flex: 1 }}>Status</div>

    <div style={{ width: 80 }}>Action</div>
  </div>
);

const ActionsMenu = ({
  payout,
  onDelete,
  onView,
  onEdit
}) => {

  const [open, setOpen] = useState(false);

  return (

    <div style={{ position: "relative" }}>

      <MoreVertical

        size={20}

        style={{ cursor: "pointer" }}

        onClick={() => setOpen(!open)}

      />

      {

        open && (

          <div

            style={{

              position: "absolute",

              right: 0,

              top: 20,

              background: "#fff",

              boxShadow: "0 4px 15px rgba(0,0,0,.15)",

              borderRadius: 8,

              overflow: "hidden",

              zIndex: 10

            }}

          >

            <div

              onClick={() => { onView(payout.id); setOpen(false); }}

              style={{

                padding: 12,

                cursor: "pointer"

              }}

            >

              View

            </div>

            <div

              onClick={() => { onEdit(payout.id); setOpen(false); }}

              style={{

                padding: 12,

                cursor: "pointer"

              }}

            >

              Edit

            </div>

            <div

              onClick={() => { onDelete(payout.id); setOpen(false); }}

              style={{

                padding: 12,

                cursor: "pointer",

                color: "red"

              }}

            >

              Delete

            </div>

          </div>

        )

      }

    </div>

  )

};

const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  } catch (e) {
    return dateStr;
  }
};

const TableRow = ({ payout, onDelete, onView, onEdit }) => (

  <div

    style={{

      display: "flex",

      padding: 15,

      borderBottom: "1px solid #eee",

      alignItems: "center"

    }}

  >

    <div style={{ flex: 2 }}>

      <div style={{ fontWeight: 600, color: "#1F2937", display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
        <span>{payout.driver?.driverName}</span>
        {(payout.driver?.vehicle?.vehicleNumber || payout.driver?.vehicle?.registrationNumber) && (
          <span style={{ fontSize: "11px", fontWeight: 500, backgroundColor: "#E8F5EE", color: "#07A95B", padding: "2px 8px", borderRadius: "12px" }}>
            {payout.driver?.vehicle?.vehicleNumber || payout.driver?.vehicle?.registrationNumber}
          </span>
        )}
      </div>
      <div style={{ fontSize: "12px", color: "#6B7280", marginTop: "4px" }}>
        {formatDate(payout.fromDate)} to {formatDate(payout.toDate)}
      </div>

    </div>

    <div style={{ flex: 1.5, fontWeight: 500, color: "#374151" }}>

      {payout.company || payout.companyName || payout.driver?.vehicle?.clientAllotments?.[0]?.client?.clientName || "N/A"}

    </div>

    <div style={{ flex: 1 }}>

      {payout.totalTrips}

    </div>

    <div style={{ flex: 1 }}>

      ₹ {payout.totalAmount}

    </div>

    <div style={{ flex: 1 }}>

      ₹ {payout.totalDeduction}

    </div>

    <div style={{ flex: 1 }}>

      ₹ {payout.payableAmount}

    </div>

    <div style={{ flex: 1 }}>

      {payout.status}

    </div>

    <div style={{ width: 80 }}>

      <ActionsMenu

        payout={payout}

        onDelete={onDelete}

        onView={onView}

        onEdit={onEdit}

      />

    </div>

  </div>

);

const DriverPayout = () => {

  const [payouts, setPayouts] = useState([]);

  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");

  const [filter, setFilter] = useState("all");
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedPayoutId, setSelectedPayoutId] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [pagination, setPagination] = useState({
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    limit: 10,
  });
  const [stats, setStats] = useState({ total: 0, paid: 0, pending: 0 });

  const fetchDriverPayouts = async (page = currentPage) => {
    try {
      setLoading(true);
      const params = {
        page,
        limit: pageSize,
      };
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (search && search.trim()) params.search = search.trim();
      if (filter && filter !== "all") params.status = filter;

      const response = await getAllDriverPayouts(params);
      if (response.success) {
        setPayouts(response.data || []);
        setPagination({
          totalCount: response.totalCount !== undefined ? response.totalCount : (response.data?.length || 0),
          totalPages: response.totalPages || 1,
          currentPage: response.currentPage || page,
          limit: response.limit || pageSize,
        });
        if (response.stats) {
          setStats(response.stats);
        }
      } else {
        setPayouts(response.data || response || []);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDriverPayouts(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, startDate, endDate, search, filter]);

  const handleSearchChange = (val) => {
    setSearch(val);
    setCurrentPage(1);
  };

  const handleFilterChange = (val) => {
    setFilter(val);
    setCurrentPage(1);
  };

  const handleStartDateChange = (val) => {
    setStartDate(val);
    setCurrentPage(1);
  };

  const handleEndDateChange = (val) => {
    setEndDate(val);
    setCurrentPage(1);
  };

  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages && newPage !== pagination.currentPage) {
      setCurrentPage(newPage);
    }
  };

  const getPageNumbers = (current, total) => {
    if (total <= 5) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const pages = [];
    if (current <= 3) {
      pages.push(1, 2, 3, 4, "...", total);
    } else if (current >= total - 2) {
      pages.push(1, "...", total - 3, total - 2, total - 1, total);
    } else {
      pages.push(1, "...", current - 1, current, current + 1, "...", total);
    }
    return pages;
  };

  const total = stats.total;
  const paid = stats.paid;
  const pending = stats.pending;

  const filtered = payouts;

  const handleDelete = async (id) => {
    const confirmDelete = await showConfirm({
      title: "Delete Payout",
      message: "Are you sure you want to delete this payout record?",
      danger: true,
      confirmLabel: "Delete",
      cancelLabel: "Cancel",
    });

    if (!confirmDelete) return;

    try {
      await deleteDriverPayout(id);
      toast.success("Payout deleted successfully");
      fetchDriverPayouts();
    } catch (err) {
      toast.error(err.response?.data?.message || "Unable to delete payout");
    }
  };

  return (
    <div>

      {/* Statistics */}
      <div
        style={{
          display: "flex",
          gap: 20,
          marginBottom: 20,
        }}
      >
        <StatCard
          value={total}
          label="Total"
          active={filter === "all"}
          onClick={() => handleFilterChange("all")}
        />

        <StatCard
          value={paid}
          label="Paid"
          active={filter === "Paid"}
          onClick={() => handleFilterChange("Paid")}
        />

        <StatCard
          value={pending}
          label="Pending"
          active={filter === "Pending"}
          onClick={() => handleFilterChange("Pending")}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          flexWrap: "wrap",
          gap: "16px"
        }}
      >


        <div style={{ display: "flex", gap: "16px", alignItems: "center", flexWrap: "wrap" }}>
          {/* Search bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: 250,
              background: "#F5F1FA",
              borderRadius: 20,
              padding: "10px 15px",
            }}
          >

            <input
              type="text"
              placeholder="Search Driver"
              value={search}
              onChange={(e) => handleSearchChange(e.target.value)}
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                background: "transparent"
              }}
            />

            <Search size={18} />

          </div>

          {/* Date range filters */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
            <span style={{ fontSize: "13px", fontWeight: 600, color: "#4B5563" }}>From:</span>
            <input
              type="date"
              value={startDate}
              max={endDate || undefined}
              onChange={(e) => handleStartDateChange(e.target.value)}
              style={{
                padding: "8px 12px",
                border: "1px solid #D1D5DB",
                borderRadius: "20px",
                fontSize: "13px",
                outline: "none",
                background: "#F5F1FA"
              }}
            />

            <span style={{ fontSize: "13px", fontWeight: 600, color: "#4B5563" }}>To:</span>
            <input
              type="date"
              value={endDate}
              min={startDate || undefined}
              onChange={(e) => handleEndDateChange(e.target.value)}
              style={{
                padding: "8px 12px",
                border: "1px solid #D1D5DB",
                borderRadius: "20px",
                fontSize: "13px",
                outline: "none",
                background: "#F5F1FA"
              }}
            />

            {(startDate || endDate) && (
              <button
                onClick={handleClearDates}
                style={{
                  background: "#EF4444",
                  color: "#fff",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "20px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: 600,
                  transition: "opacity 0.2s"
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = "0.9"}
                onMouseLeave={e => e.currentTarget.style.opacity = "1"}
              >
                Clear
              </button>
            )}
          </div>
        </div>



        <button
          onClick={() => setShowAddModal(true)}
          style={{
            background: "#20B967",
            color: "#fff",
            border: "none",
            padding: "12px 20px",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 600
          }}
        >
          + Add Driver Payout
        </button>


      </div>

      {/* Table */}
      <div
        style={{
          background: "#fff",
          borderRadius: 8,
          overflow: "hidden",
          border: "1px solid #E5E7EB",
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
        }}
      >




        <TableHeader />

        {loading ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
            }}
          >
            Loading...
          </div>
        ) : filtered.length === 0 ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
            }}
          >
            No Driver Payouts Found
          </div>
        ) : (
          filtered.map((payout) => (
            <TableRow
              key={payout.id}
              payout={payout}
              onDelete={handleDelete}
              onView={(id) => {
                setSelectedPayoutId(id);
                setShowViewModal(true);
              }}
              onEdit={(id) => {
                setSelectedPayoutId(id);
                setShowEditModal(true);
              }}
            />
          ))
        )}
      </div>

      {/* Pagination Bar */}
      {pagination.totalCount > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "16px",
            padding: "16px 20px",
            backgroundColor: "white",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <div style={{ fontSize: "14px", color: "#6B7280" }}>
            Showing{" "}
            <span style={{ fontWeight: 600, color: "#1F2937" }}>
              {(pagination.currentPage - 1) * pagination.limit + 1}
            </span>{" "}
            to{" "}
            <span style={{ fontWeight: 600, color: "#1F2937" }}>
              {Math.min(
                pagination.currentPage * pagination.limit,
                pagination.totalCount
              )}
            </span>{" "}
            of{" "}
            <span style={{ fontWeight: 600, color: "#1F2937" }}>
              {pagination.totalCount}
            </span>{" "}
            entries
          </div>

          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <button
              onClick={() => handlePageChange(pagination.currentPage - 1)}
              disabled={pagination.currentPage <= 1}
              style={{
                padding: "8px 14px",
                borderRadius: "6px",
                border: "1px solid #D1D5DB",
                backgroundColor:
                  pagination.currentPage <= 1 ? "#F3F4F6" : "white",
                color: pagination.currentPage <= 1 ? "#9CA3AF" : "#374151",
                cursor:
                  pagination.currentPage <= 1 ? "not-allowed" : "pointer",
                fontSize: "14px",
                fontWeight: 500,
                transition: "all 0.15s",
              }}
            >
              Previous
            </button>

            {getPageNumbers(pagination.currentPage, pagination.totalPages).map(
              (p, idx) => {
                if (p === "...") {
                  return (
                    <span
                      key={`ellipsis-${idx}`}
                      style={{
                        padding: "8px 6px",
                        color: "#9CA3AF",
                        fontSize: "14px",
                        userSelect: "none",
                      }}
                    >
                      ...
                    </span>
                  );
                }
                const isActive = pagination.currentPage === p;
                return (
                  <button
                    key={`page-${p}`}
                    onClick={() => handlePageChange(p)}
                    style={{
                      padding: "8px 14px",
                      borderRadius: "6px",
                      border: isActive ? "1px solid #20B967" : "1px solid #D1D5DB",
                      backgroundColor: isActive ? "#20B967" : "white",
                      color: isActive ? "white" : "#374151",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: isActive ? 600 : 500,
                      transition: "all 0.15s",
                    }}
                  >
                    {p}
                  </button>
                );
              }
            )}

            <button
              onClick={() => handlePageChange(pagination.currentPage + 1)}
              disabled={pagination.currentPage >= pagination.totalPages}
              style={{
                padding: "8px 14px",
                borderRadius: "6px",
                border: "1px solid #D1D5DB",
                backgroundColor:
                  pagination.currentPage >= pagination.totalPages
                    ? "#F3F4F6"
                    : "white",
                color:
                  pagination.currentPage >= pagination.totalPages
                    ? "#9CA3AF"
                    : "#374151",
                cursor:
                  pagination.currentPage >= pagination.totalPages
                    ? "not-allowed"
                    : "pointer",
                fontSize: "14px",
                fontWeight: 500,
                transition: "all 0.15s",
              }}
            >
              Next
            </button>
          </div>
        </div>
      )}
      {
        showAddModal &&
        <AddDriverPayoutModal

          close={() => setShowAddModal(false)}

          refresh={fetchDriverPayouts}

        />
      }
      {
        showViewModal && selectedPayoutId &&
        <ViewDriverPayoutModal
          id={selectedPayoutId}
          close={() => {
            setShowViewModal(false);
            setSelectedPayoutId(null);
          }}
        />
      }
      {
        showEditModal && selectedPayoutId &&
        <EditDriverPayoutModal
          id={selectedPayoutId}
          close={() => {
            setShowEditModal(false);
            setSelectedPayoutId(null);
          }}
          refresh={fetchDriverPayouts}
        />
      }
    </div>
  );

}

export default DriverPayout;